import _$ from 'js/api/getdata'

export const fileUrlReferenceState = {
  url: '',
}
export const fileUrlReferenceMutations = {
  setfileReferenceUrl(state, url) {
    state.fileUrlReferenceState.url = url
  },
}
export const fileUrlReferenceActions = {
  getFileReferenceUrl(context, currentData) {
    const { neid, nsid } = currentData
    _$.postData('createFileRefShortUrl', {
      neid,
      nsid,
    }).then((res) => {
      if (res.status === 200) {
        const { url } = res.data
        context.commit('setfileReferenceUrl', url)
      }
    })
  },
}
